export default __webpack_public_path__ + "assets/Manager4.png";